interface PaginationProps {
  page: number;
  pages: number;
  total: number;
  itemLabel?: string;
  onChange: (page: number) => void;
}

export function Pagination({ page, pages, total, itemLabel = "item", onChange }: PaginationProps) {
  if (pages <= 1) {
    return total ? (
      <div className="pagination">
        <span>
          {total} {itemLabel}
          {total === 1 ? "" : "s"}
        </span>
      </div>
    ) : null;
  }
  return (
    <div className="pagination">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page <= 1}
      >
        Prev
      </button>
      <span>
        Page {page} of {pages} ({total} {itemLabel}
        {total === 1 ? "" : "s"})
      </span>
      <button
        type="button"
        onClick={() => onChange(Math.min(pages, page + 1))}
        disabled={page >= pages}
      >
        Next
      </button>
    </div>
  );
}
